import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../../interceptors";
import { baseUrl } from "../../../config/config";

export default function AssessmentList() {
  const nav = useNavigate();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    document.title = "Assessments - Ample Hire";
    setLoading(true);
    axiosInstance.get(`${baseUrl}/job-posting/assessments`)
      .then((r) => setItems(Array.isArray(r.data) ? r.data : []))
      .catch(() => setItems([]))
      .finally(() => setLoading(false));
  }, []);

  const parseQs = (raw) => {
    if (!raw) return [];
    if (Array.isArray(raw)) return raw;
    try { return JSON.parse(raw); } catch { return []; }
  };

  return (
    <div className="page-enter">
      <div className="flex items-end justify-between mb-5">
        <div>
          <h1 className="text-2xl font-semibold text-vf-base">Assessments</h1>
          <p className="text-sm text-vf-muted mt-1">MCQ assessments to send to candidates.</p>
        </div>
        <button onClick={() => nav("/admin/assessments/new")} className="px-3 py-1.5 rounded bg-vf-primary text-white text-xs">
          + New assessment
        </button>
      </div>

      <div className="bg-white border border-slate-200 rounded-xl overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-xs uppercase text-vf-muted">
            <tr>
              <th className="text-left px-4 py-2 font-medium">Title</th>
              <th className="text-left px-4 py-2 font-medium">Type</th>
              <th className="text-left px-4 py-2 font-medium">Questions</th>
              <th className="text-left px-4 py-2 font-medium">Time</th>
              <th className="text-left px-4 py-2 font-medium">Pass score</th>
              <th className="text-left px-4 py-2 font-medium">Published</th>
              <th className="text-right px-4 py-2 font-medium">Actions</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {loading && <tr><td colSpan={7} className="px-4 py-6 text-center text-vf-muted text-xs">Loading…</td></tr>}
            {!loading && items.length === 0 && (
              <tr><td colSpan={7} className="px-4 py-6 text-center text-vf-muted text-xs">No assessments yet.</td></tr>
            )}
            {items.map((a) => (
              <tr key={a.id}>
                <td className="px-4 py-2 text-vf-base">{a.title}</td>
                <td className="px-4 py-2 text-vf-muted text-xs">{a.assessmentType}</td>
                <td className="px-4 py-2 text-vf-base">{parseQs(a.questions).length}</td>
                <td className="px-4 py-2 text-vf-muted text-xs">{a.timeLimitMinutes} min</td>
                <td className="px-4 py-2 text-vf-muted text-xs">{a.passingScore}%</td>
                <td className="px-4 py-2 text-vf-muted text-xs">{a.isPublished ? "Yes" : "No"}</td>
                <td className="px-4 py-2 text-right space-x-1">
                  <button onClick={() => nav(`/admin/assessments/new?id=${a.id}`)} className="px-2 py-1 rounded border border-slate-300 text-xs">Edit</button>
                  <button
                    onClick={async () => {
                      const email = prompt("Candidate email to invite:");
                      if (!email) return;
                      const r = await axiosInstance.post(`${baseUrl}/job-posting/assessments/${a.id}/invite`, { emails: [email] });
                      alert(`Invited. Token link: /assessment/${r.data.tokens[0]}`);
                    }}
                    className="px-2 py-1 rounded bg-vf-primary text-white text-xs"
                  >
                    Invite
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
